import { FC } from "react";
import { Button, Modal } from "antd";
import { CoreResource, t } from "shared/plugins/localization";
import {
  DefaultErrorMessage,
  UpdateDataSuccessfully,
} from "shared/constants/define-localization";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { returningPackingListApi } from "states/order-packing-list/order-packing-list.api";

interface IOrderReturningButtonProps {
  orderShippingId: string;
  onSuccess: () => void;
}
export const OrderReturningButton: FC<IOrderReturningButtonProps> = (props) => {
  const { orderShippingId, onSuccess } = props;
  const handleChangeStatusOrderShippingReturning = async () => {
    Modal.confirm({
      title: "Xác nhận",
      icon: <ExclamationCircleOutlined />,
      content: "Bạn có chắc muốn duyệt hoàn đơn hàng?",
      okText: "Ok",
      cancelText: "Bỏ qua",
      onOk: onSubmit,
    });
  };
  const onSubmit = async () => {
    try {
      await returningPackingListApi(orderShippingId);
      Modal.success({
        title: "Thông báo",
        content: "Cập nhật thành công",
        afterClose: () => {
          onSuccess();
        },
      });
    } catch (error: any) {
      Modal.error({
        title: "Thông báo",
        content:
          error?.response?.data?.error?.message ??
          "Lỗi hệ thống",
      });
    }
  };
  return (
    <Button
      block
      type="primary"
      danger
      onClick={handleChangeStatusOrderShippingReturning}
    >
      Duyệt hoàn
    </Button>
  );
};
